
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import ProjectHeader from "@/components/projects/ProjectHeader.vue";
import NavGrayArrow from "@/components/icons//NavGrayArrow.vue";
import ClockIcon from "@/components/icons/clockIconNew.vue";
import ExpandDownArrow from "@/components/icons/ExpandDownArrow.vue";
import ClockIconBlack from "@/components/icons/Clock-icon-black.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import UserIcon from "@/components/icons/UserIcon.vue";
import EditIconVue from "@/components/icons/EditPenIcon.vue";
import GetTimesheet from "@/apollo/projectActivities/GetTimesheet.gql";
import GetTimesheetByUserAndCompanyID from "@/apollo/projectActivities/GetTimesheetByUserAndCompanyID.gql";
import TooltipNewClick from "@/components/common/TooltipNewClick.vue";
import SubmitTimeModal from "@/components/projects/timeTracker/SubmitTimeModal.vue";
import AlertModel from "@/components/alert/AlertModel.vue";
import InsertTimesheetEntry from "@/apollo/projectActivities/InsertTimesheetEntry.gql";
import UPDATE_SHEET from "@/apollo/timesheet/UpdateTimesheet.gql";
import RejectReasonModal from "@/components/projects/timeTracker/RejectReasonModal.vue";
import PageHeadIcon from "@/components/page/PageHeadIcon.vue";
import Pagination from "@/components/v2/Pagination.vue";
import EmptyListImageProjects from "@/components/icons/emptyListImages/EmptyListImageProjects.vue";
import UPDATE_PROJECT_ACTIVITY_TIME from "@/apollo/projectActivities/UpdateProjectActivityTime.gql";
import INSERT_PROJECT_ACTIVITY_TIME from "@/apollo/projectActivities/InsertProjectActivityTime.gql";
import TabsWithRoutes from "@/components/common/TabsWithRoutes.vue";
import TabsResource from "@/components/v2/TabsResource.vue";
// import TimesheetTimeTrackerModal from/components/projects/timeTracker/TimesheetTrackerModal.vue";
import TimesheetTimeTrackerModal from "@/components/projects/timeTracker/TimesheetTimeTrackerModal.vue";
import TimesheetTimeTrackerModalManual from "@/components/projects/timeTracker/TimesheetTimeTrackerModalManual.vue";
import CheckmarkBlack from "@/components/icons/CheckMarkBlack.vue";
import GetTimesheetByUserAndCompanyIDResource from "@/apollo/projectActivities/GetTimesheetByUserAndCompanyIDResource.gql";
import GET_PROJECT_ACTIVITY_TIMES_BY_CONTRACTOR from "@/apollo/projectActivities/GetProjectActivityTimesByContractor.gql";
import GET_PROJECT_ACTIVITY_TIMES_BY_TIMESHEETID from "@/apollo/projectActivities/GetProjectActivityTimesByTimeSheetId.gql";
import GetContractorByCompanyAndUserID from "@/apollo/contractors/GetContractorByCompanyAndUserID.gql";
import VueCal from "vue-cal";
import { NOTIFICATION } from "@/entities/Events";
import DropdownFilter from "@/components/filters/DropdownFilterNew.vue";
import MultiSelectComponent from "@/components/MultiSelect.vue";
import { secondsToHMS } from "@/utils/convertSecondsToReadable";
import CrossIcon from "@/components/icons/CrossIconNew.vue";
import GET_AGGREATED_COUNT_RES from "@/apollo/timesheet/GetAggeratedCountByResource.gql";
import CrossIconHover from "@/components/icons/CrossIconHover.vue";
import Message from "@/data/notificationsMessages";
import {
  STATUS,
  VALUE_TO_STATUS,
  TIMESHEET_STATUSES,
} from "@/entities/TimesheetStatus";
import TableView from "@/components/v2/table/NewTableResource.vue";
import UPDATE_PROJECT_ACTIVITY_TIMES from "@/apollo/projectActivities/UpdateProjectActivitiesTime.gql";

import {
  Project_Activity,
  Project_Activity_Time,
  User,
  Timesheet,
  Company,
  Contractor,
  Timesheet_Order_By,
  Timesheet_Bool_Exp,
  Project_Activity_Time_Bool_Exp,
} from "@/generated/graphql";
import moment from "moment";
import UiButton from "@/components/button/ui-button.vue";
import GET_COMPANIES from "@/apollo/company/GetCompanies.gql";
import DropdownOption from "@/entities/DropdownOption";
import Tabs from "@/components/v2/ListTabs.vue";
import NoDataIcon from "@/components/icons/NoDataIcon.vue";

@Component({
  components: {
    AlertModel,
    ProjectHeader,
    TabsWithRoutes,
    LoadingOverlay,
    NoDataIcon,
    CrossIcon,
    CrossIconHover,
    Pagination,
    VueCal,
    Tabs,
    TabsResource,
    ClockIcon,
    ClockIconBlack,
    TableView,
    ExpandDownArrow,
    CheckmarkBlack,
    TooltipNewClick,
    RejectReasonModal,
    SubmitTimeModal,
    PageHeadIcon,
    UiButton,
    NavGrayArrow,
    TimesheetTimeTrackerModal,
    UserIcon,
    DropdownFilter,
    EmptyListImageProjects,
    TimesheetTimeTrackerModalManual,
    EditIconVue,
    MultiSelectComponent,
  },
  apollo: {
    companies: {
      query: GET_COMPANIES,
      variables() {
        return this.companiesQuery;
      },
      update(data) {
        return data.companies;
      },
    },
    aggeratedCount: {
      query: GET_AGGREATED_COUNT_RES,
      variables() {
        return {
          user_id: this.currentUser.id,
        };
      },
      update(data: any) {
        const newBadges = [...this.actionTabs];
        newBadges[0].badge = data.allCount?.aggregate?.count;
        newBadges[1].badge = data.pendingCount?.aggregate?.count;
        newBadges[2].badge = data.approvedCount?.aggregate?.count;
        newBadges[3].badge = data.rejectedCount?.aggregate?.count;
        this.actionTabs = newBadges;
        return data;
      },
    },
    projectActivityTimes: {
      query: GET_PROJECT_ACTIVITY_TIMES_BY_TIMESHEETID,
      variables() {
        // return {
        //   timeSheetID: this.timeSheetId,
        // };
        return {
          where: this.getActivitiesWhere,
        };
      },
      update(data) {
        this.eventItems = data.project_activity_time.map((time) => {
          let start = new Date(moment(time.tracked_date).local().toDate());
          let end = new Date(
            moment(time.tracked_date).add(time.time, "seconds").local().toDate()
          );
          if (time.start_time !== null && time.end_time !== null) {
            start = new Date(
              moment(time.tracked_date + " " + time.start_time).format(
                "YYYY-MM-DD HH:mm:ss"
              )
            );
            end = new Date(
              moment(time.tracked_date + " " + time.end_time).format(
                "YYYY-MM-DD HH:mm:ss"
              )
            );
          }
          return {
            start: start,
            end: end,
            content: time.project_activity.title,
            title: time.id,
            contentFull: time.project_activity.id,
            class: time.status,
            background: time.status === "APPROVED" ? true : false,
            resizable: time.status === "APPROVED" ? false : true,
          };
        });
        return data.project_activity_time;
      },
      skip() {
        // return !this.timeSheetId;
        return this.isAllowfetchActivities;
      },
    },
    contractor: {
      query: GetContractorByCompanyAndUserID,
      variables() {
        return {
          companyID: this.company?.[0]?.id,
          userID: this.currentUser?.id,
        };
      },
      skip() {
        return !this.company?.[0]?.id || !this.currentUser?.id;
      },
    },
    timesheetList: {
      query: GetTimesheetByUserAndCompanyID,
      skip() {
        return !this.company?.[0]?.id || !this.currentUser?.id;
      },
      variables() {
        return {
          userID: this.currentUser.id,
          companyID: this.company?.[0].id,
        };
      },

      update(data) {
        return data.timesheet;
      },
    },
    timesheet: {
      query: GetTimesheetByUserAndCompanyIDResource,
      variables() {
        const variables = {
          limit: this.limit,
          offset: this.offset,
          order_by: this.contructOrderBy,
          where: this.where,
        };
        return variables;
      },
      update(data) {
        this.count = data.timesheet_aggregate?.aggregate?.count;
        return data.timesheet;
      },
      skip() {
        return true;
      },
    },
  },
})
export default class ContractorTimesheets extends Vue {
  @Prop({ type: Object, required: true }) readonly currentUser!: User;

  projectActivityTimes: Project_Activity_Time[] = [];
  isHovered: boolean = false;
  contractor_activities: Project_Activity[] = [];
  contractor: Contractor = null;
  activeActivity: Project_Activity = null;
  showDiscalimer: boolean = false;
  activeTimeEntry: Project_Activity_Time = null;
  eventItems: any[] = [];
  elapsedTime: number = 0;
  weekStatus: string = null;

  submitTimeModalOpen: boolean = false;
  trackedDate: Date = null;
  orderBy: Timesheet_Order_By[] = [];
  rejectReasonModalOpen: boolean = false;
  weekDisable: boolean = false;
  timesheetList: Timesheet[] = [];
  timesheet: Timesheet[] = [];
  timerStart: string = null;
  timerEnd: string = null;
  week: Date[] = [];
  activeTabIndex: number = 0;
  submitTime: boolean = false;
  activeTabIndexRes: number = Number(this.$route.query.tab || 0);
  timeTrackerOpen: boolean = false;
  timeTrackerOpenManual: boolean = false;
  currentCellTime: Date = new Date();
  canPause = false;
  currentPage: number = Number(this.$route.query.page || 1);
  companies?: Company[] = [];
  count: number = 0;
  company: DropdownOption[] = [];
  isNoCompany: boolean = false;
  timeSheetId: string = "";
  limit: number = Number(this.$route.query.limit || 10);
  where: Timesheet_Bool_Exp = {};
  sortBy = this.$route.query.sort_by || "created_at";
  offset: number =
    this.currentPage >= 1 ? (this.currentPage - 1) * this.limit : 0;
  sortDirection = this.$route.query.sort_direction || null;

  get isAllowfetchActivities() {
    return this.company?.[0]?.id && this.contractor[0]?.id;
  }

  @Watch("timeSheetId")
  @Watch("company")
  @Watch("week")
  @Watch("contractor")
  getProjectActivityTimes() {
    if (this.company?.[0]?.id && this.contractor?.[0]?.id) {
      this.$apollo.queries.projectActivityTimes.skip = false;
      // this.$apollo.queries.projectActivityTimes.refetch()
    }
  }
  get getActivitiesWhere() {
    const startDate = this.week[0]?.toISOString()?.split("T")[0];
    const endDate = this.week[1]?.toISOString()?.split("T")[0];
    let object = {
      _and: [
        { tracked_date: { _gte: startDate } },
        { tracked_date: { _lte: endDate } },
        { contractor_id: { _eq: this.contractor[0]?.id } },
        {
          contractor: {
            company_id: { _eq: this.company?.[0]?.id },
          },
        },
      ],
    } as Project_Activity_Time_Bool_Exp;
    if (this.timeSheetId) {
      object = { _or: [{ timesheet_id: { _eq: this.timeSheetId } }, object] };
    }
    return object;
  }

  @Watch("timesheetList")
  checkTimeSheetId() {
    this.getTimesheetId();
    this.getDisableStatus();
  }

  tabs = [{ name: "Calendar" }, { name: "List" }];

  actionTabs = [
    { name: "All", badge: 0 },
    { name: "Pending Approval", badge: 0 },
    { name: "Approved", badge: 0 },
    { name: "Rejected", badge: 0 },
  ];

  changeActiveTab(index) {
    if (this.activeTabIndex !== index) {
      this.activeTabIndex === index;
    } else {
      this.activeTabIndex = this.activeTabIndex;
    }
  }
  columns = [
    { label: "Comapny", field: "company", sort: true },
    { label: "Period", field: "period", sort: true },
    { label: "Total hours", field: "hours" },
    { label: "Status", field: "status", sort: false },
  ];
  get isTimesheetEmpty() {
    return (
      !!this.timesheetList &&
      !!this.projectActivityTimes &&
      !!this.companies?.length
    );
  }
  get active_companies(): DropdownOption[] {
    const getComapny = this.companies?.map((activity) => {
      return {
        name: activity.business_name,
        id: activity.id,
      };
    });
    if (this.companies.length === 1) {
      this.showDiscalimer = false;
      this.company = getComapny;
    } else {
      this.showDiscalimer = true;
    }
    return getComapny;
  }

  get active_company() {
    if (this.company) {
      return this.company;
    }
    return [];
  }

  onLimitChange(limit) {
    const lmit = this.limit;
    this.limit = Number(limit);
    if (lmit < this.limit) {
      const newPages = Math.ceil(this.count / this.limit);
      if (this.currentPage > newPages) {
        this.currentPage = newPages;
      }
    }
  }

  resetSheetValues() {
    this.timeSheetId = "";
    this.weekDisable = false;
    this.weekStatus = "UNSUBMITTED";
    this.eventItems = [];
    this.projectActivityTimes = [];
    this.timesheetList = [];
  }
  setCompany(input: DropdownOption[]) {
    this.resetSheetValues();
    this.company = input;
  }
  closeCompanyModel() {
    this.isNoCompany = false;
  }
  handleSort({ sortBy, sortDirection }) {
    this.sortBy = sortBy;
    this.sortDirection = sortDirection;
    const { scroll, ...rest } = this.$route.query;
    this.$router.push({
      name: this.$route.name,
      query: {
        ...rest,
        sort_by: sortBy,
        sort_direction: sortDirection,
      },
    });
    this.orderBy = this.contructOrderBy;
  }

  get contructOrderBy() {
    const orderBy = { is_new: "desc" };
    let orderby = [];
    if (this.sortBy === "company") {
      orderby = [
        {
          ...orderBy,
          company: {
            business_name: this.sortDirection,
          },
        },
      ];
    } else if (this.sortBy === "period") {
      orderby = [
        {
          ...orderBy,
          start_date: this.sortDirection,
        },
      ];
    } else if (this.sortBy === "status") {
      orderby = [{ ...orderBy, status: this.sortDirection }];
    } else if (this.sortBy === "created_at") {
      orderby = [{ ...orderBy, created_at: "desc" }];
    } else {
      orderby = [orderBy];
    }
    return orderby;
  }

  get companiesQuery(): Object {
    const conditions: any[] = [
      {
        contractors: {
          user_id: { _eq: this.currentUser.id },
          deleted: { _eq: false },
          approved: { _eq: true },
        },
      },
    ];

    return {
      where: { _and: conditions },
      userId: this.currentUser.id,
    };
  }

  getBodyRowClasses(row: any) {
    if (row.is_new) return " new_sheet";
    return "";
  }

  downloadAllTimesheetsCSV() {
    this.downloadTimesheetsCSV(this.timesheet);
  }

  status(value) {
    return STATUS[value];
  }

  downloadTimesheetsCSV(timesheet: Timesheet[]) {
    // Define the header for CSV file
    const csvHeader = "ID,Company Name,Tracked Time,Start Date,End Date\n";

    // Map timesheets to CSV rows
    const csvRows = timesheet
      .map((ts: any) => {
        // const contractorGivenName = ts.contractor.user.given_name || "";
        // const contractorFamilyName = ts.contractor.user.family_name || ""; // Assuming family_name is the correct key
        const comapnyName = ts.company?.business_name || "";
        const trackedTime =
          this.convertSecondsToHoursMinutesSeconds(ts.tracked_time) || "";

        const startDate = ts.start_date || "";
        const endDate = ts.end_date; // Assuming multiple end times can exist

        // Combine data in CSV format
        return `${ts.id},"${comapnyName}",${trackedTime},${startDate},"${endDate}"`;
      })
      .join("\n");

    // Combine header and rows
    const csvData = csvHeader + csvRows;

    // Create a Blob with the CSV data
    const blob = new Blob([csvData], { type: "text/csv" });

    // Create a link to download the Blob
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.setAttribute("hidden", "");
    a.setAttribute("href", url);
    a.setAttribute("download", "timesheets.csv");
    document.body.appendChild(a);
    a.click();

    // Clean up
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  convertSecondsToHoursMinutesSeconds(seconds) {
    if (typeof seconds !== "number" || isNaN(seconds) || seconds < 0) {
      return "0 s";
    }
    const time = secondsToHMS({ duration: seconds });
    const { hours: hs, minutes: ms, seconds: sc } = time;
    let result = "";
    if (hs > 0) {
      result += hs + " h ";
    }
    if (ms > 0) {
      result += ms + " m ";
    }
    if (sc > 0) {
      result += sc + " s";
    }
    if (result === "") {
      result = "0 s";
    }

    return result;
  }
  changePage(direction) {
    const nextPage = this.currentPage + direction;
    if (nextPage > 0 && nextPage <= this.totalPages) {
      //set limit in query
      this.currentPage = nextPage;
    }
  }
  get totalPages() {
    return Math.ceil(this.count / this.limit);
  }

  get isLoaded(): boolean {
    return (
      this.$apollo.queries?.projectActivityTimes?.loading ||
      this.$apollo.queries?.companies?.loading ||
      this.$apollo.queries.timesheetList.loading ||
      this.$apollo.queries.timesheet.loading
    );
  }

  @Watch("currentPage")
  @Watch("activeTabIndexRes")
  @Watch("limit")
  changeRouteQuery() {
    const offset = (this.currentPage - 1) * this.limit;
    this.offset = offset > 0 ? offset : 0;
    const { scroll, ...rest } = this.$route.query;
    this.$router.push({
      name: this.$route.name, // Keep the current route name
      query: {
        ...rest, // Spread the existing query parameters
        tab: this.activeTabIndexRes?.toString(), // Update the 'page' parameter
        limit: this.limit?.toString(), // Update the 'limit' parameter
        page: this.currentPage?.toString(), // Update the 'page' parameter
        offset: this.offset?.toString(), // Update the 'page' parameter
      },
    });
  }

  displayTimer() {
    var timerInterval = window.setInterval(() => {
      if (
        document.getElementById("timerLabel") &&
        localStorage.getItem("timerRunning")
      ) {
        document.getElementById("timerLabel").innerHTML = this.timerTime();
      }
    }, 1000);
  }
  created(): void {
    this.$root.$on("timerStopped", () => {
      this.$apollo.queries.projectActivityTimes.refetch();
    });
    this.$root.$on("timerPaused", () => {
      this.stopTimer();
    });
    this.where = this.buildWhere;
    this.orderBy = this.contructOrderBy;
    this.$apollo.queries.timesheet.skip = false;
  }

  get buildWhere(): Timesheet_Bool_Exp {
    let where;
    let sheetStatus = { status: { _neq: "UNSUBMITTED" } };
    if (
      this.activeTabIndexRes &&
      this.activeTabIndexRes > 0 &&
      this.activeTabIndexRes < this.actionTabs.length
    ) {
      const status =
        VALUE_TO_STATUS[this.actionTabs[this.activeTabIndexRes].name];
      where = {
        _and: {
          status: { _eq: status, _neq: "UNSUBMITTED" },
        },
      };
      sheetStatus = where;
    }
    where = { ...sheetStatus, user_id: { _eq: this.currentUser.id } };

    return where;
  }

  checkDateWeekDisable(date: Date) {
    let isDisable = false;
    const dateMilis = new Date(date).getTime();
    this.timesheetList.forEach((timesheet) => {
      const startTime = new Date(timesheet.start_date).getTime();
      const endTime = new Date(timesheet.end_date).getTime();
      const isBetween = dateMilis <= endTime && dateMilis >= startTime;
      if (
        isBetween &&
        timesheet.status !== "REJECTED" &&
        timesheet.status !== "UNSUBMITTED"
      ) {
        isDisable = true;
      }
    });
    return isDisable;
  }
  getTimesheetId() {
    let timesheetId = null;
    this.timesheetList.forEach((timesheet) => {
      if (
        timesheet.start_date >= moment(this.week[0]).format("YYYY-MM-DD") &&
        timesheet.end_date <= moment(this.week[1]).format("YYYY-MM-DD")
      ) {
        timesheetId = timesheet.id;
      }
    });
    this.timeSheetId = timesheetId;
    return timesheetId;
  }
  gettimeRangeFormat(start, end) {
    // const startDate = start ? moment(start).format("MMM DD") : "";
    // const endDate = end ? moment(end).format("MMM DD, YYYY") : "";
    const startDate = start ? moment(start).format("DD MMM, YYYY") : "";
    const endDate = end ? moment(end).format("DD MMM, YYYY") : "";
    return `${startDate} -
      ${endDate}`;
  }

  createTimeSheet(status = "SUBMITTED") {
    this.$apollo
      .mutate({
        mutation: InsertTimesheetEntry,
        variables: {
          timesheet: {
            // contractor_id: this.projectActivityTimes[0]?.contractor_id,
            contractor_id: this.contractor[0]?.id,
            user_id: this.currentUser.id,
            company_id: this.company[0].id,
            start_date: moment(this.week[0]).format("YYYY-MM-DD"),
            end_date: moment(this.week[1]).format("YYYY-MM-DD"),
            type: "WEEKLY",
            status,
            tracked_time: this.totalTimePerWeekSubmit(),
          },
        },
      })
      .then((d) => {
        if (d.data?.insert_timesheet_one?.id) {
          this.timeSheetId = d.data.insert_timesheet_one.id;
        }
        this.$apollo.queries.timesheetList.refetch();
      });
  }
  async handleApproveRejectTimesheetPorjectActivitiesTime(status: string) {
    return await this.$apollo
      .mutate({
        mutation: UPDATE_PROJECT_ACTIVITY_TIMES,
        variables: {
          where: { timesheet_id: { _eq: this.getTimesheetId() } },
          set: {
            status: status,
          },
        },
      })
      .catch((e) => console.log("error"));
  }

  @Watch("activeTabIndexRes")
  onTabChange(newTabIndex: number, oldTabIndex: number) {
    if (newTabIndex !== oldTabIndex) {
      const newWhere = this.buildWhere; // Update where based on newTabIndex
      this.$apollo.queries.timesheet.setVariables({
        where: newWhere,
        limit: this.limit,
        offset: 0,
        order_by: this.contructOrderBy, // Assuming this is defined in your component
      });
      this.$apollo.queries.timesheet.refetch(); // Refetch the timesheet query with updated variables
    }
  }
  submitHours() {
    const isNotsubmitted = this.weekStatus === "UNSUBMITTED";
    if (this.weekStatus === "REJECTED" || this.weekStatus === "UNSUBMITTED") {
      var obj = {
        status: "SUBMITTED",
      };
      if (this.weekStatus === "UNSUBMITTED") {
        obj["created_at"] = moment.utc().format();
      }
      this.$apollo
        .mutate({
          mutation: UPDATE_SHEET,
          variables: {
            set: {
              // contractor_id: this.projectActivityTimes[0].contractor_id,
              contractor_id: this.contractor[0]?.id,
              user_id: this.currentUser.id,
              company_id: this.company[0].id,
              tracked_time: this.totalTimePerWeekSubmit(),
              ...obj,
            },
            id: this.getTimesheetId(),
          },
        })
        .then((d) => {
          this.handleApproveRejectTimesheetPorjectActivitiesTime("CREATED");
          this.$apollo.queries.timesheetList.refetch();
        });
      this.$eventBus.emit(
        NOTIFICATION,
        Message.successMessage(
          `Timesheet has been successfully ${
            isNotsubmitted ? "submitted" : "resubmitted"
          } `
        )
      );
      this.$apollo.queries.timesheetList.refetch();
      this.weekDisable = true;
      this.weekStatus = "SUBMITTED";
      return;
    }

    this.createTimeSheet();
    this.$eventBus.emit(
      NOTIFICATION,
      Message.successMessage("Timesheet has been successfully submitted")
    );

    this.weekDisable = true;
    this.weekStatus = "SUBMITTED";
    return;
  }
  dateRange(view) {
    return `${moment(view.startDate).format("MMM DD")} - ${moment(
      view.endDate
    ).format("MMM DD YYYY")}`;
  }
  getWeekStatus() {
    let status = null;
    this.timesheetList.forEach((timesheet) => {
      if (
        timesheet.start_date >= moment(this.week[0]).format("YYYY-MM-DD") &&
        timesheet.end_date <= moment(this.week[1]).format("YYYY-MM-DD")
      ) {
        status = timesheet.status;
      }
    });
    this.weekStatus = status;
  }
  get canEdit() {
    if (this.weekDisable) {
      return false;
    }
    return {
      title: false,
      drag: true,
      resize: true,
      delete: false,
      create: true,
    };
  }
  get rejectionReason() {
    let reason = null;
    this.timesheetList.forEach((timesheet) => {
      if (
        timesheet.start_date >= moment(this.week[0]).format("YYYY-MM-DD") &&
        timesheet.end_date <= moment(this.week[1]).format("YYYY-MM-DD")
      ) {
        reason = timesheet.reject_reason;
      }
    });
    return reason;
  }
  get events(): any[] {
    if (localStorage.getItem("timerRunning")) {
      //if its been less than 60 mins, set the end time to 60 mins by default
      // let endTime = new Date();
      let endTime = this.getCurrentTime();
      if (
        // new Date().getTime() -
        endTime.getTime() -
          new Date(localStorage.getItem("startTime")).getTime() <
        3600000
      ) {
        endTime = new Date(
          new Date(localStorage.getItem("startTime")).getTime() + 3600000
        );
      }
      this.eventItems.push({
        start: new Date(localStorage.getItem("startTime")),
        end: endTime,
        background: true,
        content: JSON.parse(localStorage.getItem("activity")).title,
        class: "TIMER",
        resizable: false,
      });
      this.displayTimer();
    }
    return this.eventItems;
  }
  getDisableDays(): String[] {
    let disable_arr: String[] = [];
    if (this.weekDisable) {
      for (let i = 0; i < 7; i++) {
        disable_arr.push(
          moment(this.week[0].setDate(this.week[0].getDate() + i)).format(
            "YYYY-MM-DD"
          )
        );
      }
      return disable_arr;
    }
  }
  getDisableStatus() {
    this.timesheetList.forEach((timesheet) => {
      if (
        timesheet.start_date >= moment(this.week[0]).format("YYYY-MM-DD") &&
        timesheet.end_date <= moment(this.week[1]).format("YYYY-MM-DD") &&
        timesheet.status !== "REJECTED" &&
        timesheet.status !== "UNSUBMITTED"
      ) {
        this.weekDisable = true;
      }
    });
    this.getWeekStatus();
  }
  getWeek($event) {
    this.weekDisable = false; //reset weekDisable
    this.week = [$event.startDate, $event.endDate];
    const calref = this.$refs.vuecalRef as any;
    this.scrollTo9();
    const startTime = new Date($event.startDate).getTime();
    const endTime = new Date($event.endDate).getTime();
    const currentDate = new Date().getTime();
    const isBetween = currentDate <= endTime && currentDate >= startTime;
    this.currentCellTime = isBetween ? new Date() : $event.startDate;
    calref.selectedDate = this.currentCellTime;
    this.getDisableStatus();
    this.getTimesheetId();
  }
  scrollTo9() {
    const calendar = document.querySelector("#vuecal .vuecal__bg");
    const hours = new Date().getHours() + new Date().getMinutes() / 60;
    calendar.scrollTo({ top: hours * 120, behavior: "smooth" });
  }
  get calculateTotalWeekTime() {
    let totalTime = 0;
    this.projectActivityTimes.forEach((time) => {
      if (
        time.tracked_date >= moment(this.week[0]).format("YYYY-MM-DD") &&
        time.tracked_date <= moment(this.week[1]).format("YYYY-MM-DD")
      ) {
        totalTime += time.time;
      }
    });
    return totalTime;
  }
  get getRanderWeekTotalTime() {
    const totalWeektime = this.calculateTotalWeekTime;
    let weektime = ``;
    if (!totalWeektime) {
      return (weektime += "0h");
    }
    const weektFormat = secondsToHMS({ duration: totalWeektime });
    if (weektFormat) {
      if (weektFormat.hours) {
        weektime = `${weektFormat.hours}h `;
      }
      if (weektFormat.minutes) {
        weektime += `${weektFormat.minutes}m`;
      }
    }
    return weektime;
  }
  get totalTimePerWeek() {
    const totalTime = this.calculateTotalWeekTime;
    return Math.ceil(totalTime / 3600);
  }
  totalTimePerWeekSubmit() {
    const totalTime = this.calculateTotalWeekTime;
    return totalTime;
  }
  getCurrentTime() {
    const localstorageTrackedDate = localStorage.getItem("tracked_date");
    if (localstorageTrackedDate) {
      let endTime = new Date(localstorageTrackedDate);
      const currentTime = new Date();
      const currseconds = currentTime.getSeconds();
      const currminutes = currentTime.getMinutes();
      const currhours = currentTime.getHours();
      const currmilis = currentTime.getMilliseconds();
      endTime.setHours(currhours);
      endTime.setSeconds(currseconds);
      endTime.setMinutes(currminutes);
      endTime.setMilliseconds(currmilis);
      return endTime;
    }
    return new Date();
  }
  timerTime() {
    // const now = new Date();
    const now = this.getCurrentTime();
    const timeDifference =
      now.getTime() - new Date(localStorage.getItem("startTime")).getTime();
    const hours = Math.floor(timeDifference / (1000 * 60 * 60));
    const minutes = Math.floor(
      (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
    );
    const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  }
  stopTimer(): void {
    // localStorage.setItem('timerRunning', '0');
    var timerInterval = Number(localStorage.getItem("appTimer"));
    window.clearInterval(timerInterval);
    localStorage.removeItem("appTimer");
  }
  discardTimer(): void {
    localStorage.removeItem("startTime");
    localStorage.removeItem("stopTime");
    localStorage.removeItem("timerRecorded");
    localStorage.removeItem("timerRunning");
    localStorage.removeItem("activity");
    localStorage.removeItem("appTimer");
    localStorage.removeItem("timerOwner" + this.currentUser.id);
    localStorage.removeItem("tracked_date");

    if (localStorage.getItem("timerInterval")) {
      var timerInterval = Number(localStorage.getItem("timerInterval"));
      window.clearInterval(timerInterval);
      localStorage.removeItem("timerInterval");
    }
  }
  updateTrackedTimes(event) {
    if (event.class === "TIMER") {
      return;
    }
    const time = this.projectActivityTimes.find(
      (time) => time.id === event.event.title
    );
    const start = event.event.start;
    const end = event.event.end;
    const timeDiff = (end.getTime() - start.getTime()) / 1000;
    var obj = {
      time: timeDiff,
      start_time: moment(start).format("HH:mm:ss"),
      end_time: moment(end).format("HH:mm:ss"),
      tracked_date: moment(start).format("YYYY-MM-DD"),
    };
    if (this.checkForTimeOverlap({ obj, id: time.id })) {
      this.$apollo.queries.projectActivityTimes.refetch();
      return;
    }
    this.$apollo.mutate({
      mutation: UPDATE_PROJECT_ACTIVITY_TIME,
      variables: {
        id: time.id,
        obj: obj,
      },
    });
    this.projectActivityTimes = this.projectActivityTimes.map((time) => {
      if (time.id === event.event.title) {
        time.start_time = obj.start_time;
        time.end_time = obj.end_time;
        time.time = obj.time;
        time.tracked_date = moment(obj.tracked_date).format("YYYY-MM-DD");
      }
      return time;
    });
  }
  checkForTimeOverlap(updateTime) {
    let overlap = false;
    this.projectActivityTimes.forEach((time) => {
      if (updateTime.id !== time.id) {
        if (
          moment(updateTime.obj.tracked_date).format("YYYY-MM-DD") ==
          time.tracked_date
        ) {
          if (
            updateTime.obj.start_time > time.start_time &&
            updateTime.obj.start_time < time.end_time
          ) {
            overlap = true;
            this.$eventBus.emit(
              NOTIFICATION,
              Message.errorMessage(
                "Time overlap with " + time.project_activity.title
              )
            );
            return overlap;
          }
          if (
            updateTime.obj.end_time > time.start_time &&
            updateTime.obj.end_time < time.end_time
          ) {
            overlap = true;
            this.$eventBus.emit(
              NOTIFICATION,
              Message.errorMessage(
                "Time overlap with " + time.project_activity.title
              )
            );
            return overlap;
          }
          if (
            updateTime.obj.start_time < time.start_time &&
            updateTime.obj.end_time > time.end_time
          ) {
            overlap = true;
            this.$eventBus.emit(
              NOTIFICATION,
              Message.errorMessage(
                "Time overlap with " + time.project_activity.title
              )
            );
            return overlap;
          }
        }
      }
    });
    return overlap;
  }
  onCellClick(event) {
    if (!this.company[0]) {
      this.isNoCompany = true;
      return;
    }
    if (!this.weekDisable) {
      this.currentCellTime = event;
      this.openTimeTrackerModal(event);
    }
  }
  openTimeTrackerModalManual(event): void {
    if (!this.company[0]) {
      this.isNoCompany = true;
      return;
    }
    if (event) {
      this.timeTrackerOpenManual = true;
    }
  }
  openTimeTrackerModal(event): void {
    if (!this.company[0]) {
      this.isNoCompany = true;
      return;
    }
    if (!this.weekDisable) {
      if (!this.getTimesheetId()) {
        this.createTimeSheet("UNSUBMITTED");
      }
      if (event) {
        if (!this.submitTimeModalOpen) {
          if (localStorage.getItem("activity") && event.class == "TIMER") {
            this.canPause = true;
            this.activeActivity = JSON.parse(localStorage.getItem("activity"));
          } else if (event.contentFull) {
            this.activeActivity = this.contractor_activities.find(
              (activity) => activity.id === event.contentFull
            );
            this.activeTimeEntry = this.projectActivityTimes.find(
              (time) => time.id === event.title
            );
          } else if (event.class === "") {
            this.trackedDate = event.start;
            this.timerStart = moment(event.start).format("HH:mm:ss");
            this.timerEnd = moment(event.end).format("HH:mm:ss");
          }
          if (this.activeTabIndex === 0) this.timeTrackerOpen = true;
          if (this.activeTabIndex === 1) this.timeTrackerOpenManual = true;
        }
      } else if (!event) {
        if (localStorage.getItem("activity")) {
          this.activeActivity = JSON.parse(localStorage.getItem("activity"));
        }
        if (this.activeTabIndex === 0) this.timeTrackerOpen = true;
        if (this.activeTabIndex === 1) this.timeTrackerOpenManual = true;
      }
    }
  }
  openRejectionReason() {
    this.rejectReasonModalOpen = true;
  }
  async closeTimeTrackerModal(isManual) {
    isManual === true
      ? (this.timeTrackerOpenManual = false)
      : (this.timeTrackerOpen = false);
    this.activeActivity = null;
    this.activeTimeEntry = null;
    this.canPause = false;
    this.trackedDate = null;
    this.timerStart = null;
    this.timerEnd = null;
    this.$apollo.queries.projectActivityTimes.refetch();
    if (!localStorage.getItem("timerRunning")) {
      await this.$apollo.queries.projectActivityTimes.refetch();
    }
    if (localStorage.getItem("timerRunning")) {
      //if its been less than 60 mins, set the end time to 60 mins by default
      // let endTime = new Date();
      let endTime = this.getCurrentTime();
      if (
        // new Date().getTime() -
        endTime.getTime() -
          new Date(localStorage.getItem("startTime")).getTime() <
        3600000
      ) {
        endTime = new Date(
          new Date(localStorage.getItem("startTime")).getTime() + 3600000
        );
      }
      this.eventItems.push({
        start: new Date(localStorage.getItem("startTime")),
        end: endTime,
        background: true,
        content: JSON.parse(localStorage.getItem("activity")).title,
        class: "TIMER",
        resizable: false,
      });
      this.displayTimer();
    }
  }

  stopButton(e) {
    e.stopPropagation();
    this.activeActivity = JSON.parse(localStorage.getItem("activity"));
    const time = this.getCurrentTime();
    this.elapsedTime =
      // (new Date().getTime() -
      (time.getTime() - new Date(localStorage.getItem("startTime")).getTime()) /
      1000;
    this.submitTimeModalOpen = true;
  }

  get skipTimeSheetQuery() {
    return !this.currentUser?.id;
  }
  get timesheetQuery() {
    return {
      where: {
        user_id: { _eq: this.currentUser.id },
        status: { _neq: "UNSUBMITTED" },
      },
    };
  }

  closeSubmitTimeModal() {
    this.submitTimeModalOpen = false;
    this.activeActivity = null;
    if (this.submitTime) {
      this.saveTimer();
    }
  }
  async saveTimer(): Promise<void> {
    this.stopTimer();
    const tracktime = this.getCurrentTime();
    // localStorage.setItem("stopTime", new Date().toString());
    localStorage.setItem("stopTime", tracktime.toString());
    var time = 0;
    var startTime = new Date(localStorage.getItem("startTime"));
    var endTime = new Date(localStorage.getItem("stopTime"));
    if (
      !localStorage.getItem("startTime") ||
      !localStorage.getItem("stopTime")
    ) {
      time = 0;
    } else {
      var diff = endTime.getTime() - startTime.getTime();
      time = diff / 1000;
    }
    var activity = JSON.parse(localStorage.getItem("activity"));
    var projectActivityTime: any = {
      notes: activity.note || "",
      timesheet_id: this.getTimesheetId(),
      time: time,
      start_time: new Date(startTime).toTimeString().split(" ")[0],
      end_time: new Date(endTime).toTimeString().split(" ")[0],
      tracked_date: new Date(localStorage.getItem("tracked_date")),
    };

    if (activity.isEdit) {
      await this.$apollo.mutate({
        mutation: UPDATE_PROJECT_ACTIVITY_TIME,
        variables: {
          id: activity.activity_id,
          obj: projectActivityTime,
        },
      });
    } else {
      projectActivityTime.activity_id = activity.id;
      (projectActivityTime.contractor_id = activity.contractor_id),
        await this.$apollo.mutate({
          mutation: INSERT_PROJECT_ACTIVITY_TIME,
          variables: {
            projectActivityTime: projectActivityTime,
          },
        });
    }
    this.$eventBus.emit(
      NOTIFICATION,
      Message.successMessage("Time tracked has been successfully added")
    );
    this.discardTimer();
    if (this.$apollo.queries.projectActivityTimes) {
      await this.$apollo.queries.projectActivityTimes.refetch();
    }
    this.activeActivity = null;
    this.$root.$emit("timerStopped");
  }
}
